export default "__VITE_ASSET__DFM$xx7b__"